import { h, Component } from 'preact';
import { shallowEqual } from '../../lib/util';
import { stockAPIStreamer } from '@os/cloudquote';
import StockInfoTable from '../stock-info-table';

/*
 * A table of stocks, data is passed in by symbol
 * wraps a StockInfoTable component and handles subscribing
 * to streaming data;
 */

export default class StockSymbolTable extends Component {
	onData = (data) => {
		data && this.setState({ data });
	};

	componentWillMount() {
		// Setup the streaming data
		let { symbols } = this.props;
		this.streamer = stockAPIStreamer(symbols, 'getStockPrice').on('data', this.onData);
	}

	componentWillReceiveProps(nextProps) {
		// Update the streamer if the symbols changed
		if (!shallowEqual(this.props.symbols, nextProps.symbols)) {
			this.streamer.stream(nextProps.symbols);
		}
	}

	componentWillUnmount() {
		if (this.streamer) this.streamer.end();
	}

	render(props, { data }) {
		return <StockInfoTable {...props} data={data} />;
	}
}
